import treeMenu from './treeMenu';
export default treeMenu;



// WEBPACK FOOTER //
// ./src/components/treeMenu/index.js